import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import OttCard from "./OttCard";

const OttCarousel = ({ currentItem, id }: any) => {
  return (
    <div className="col-xl-9" style={{ position: "relative" }}>
      <h4 className="title" style={{ marginBottom: "16px" }}>
        {currentItem?.name}
      </h4>
      <Swiper
        modules={[Navigation]}
        slidesPerView={4}
        observer={true}
        loop={false}
        spaceBetween={16}
        breakpoints={{
          1500: { slidesPerView: 4 },
          1200: { slidesPerView: 4 },
          992: { slidesPerView: 4 },
          768: { slidesPerView: 3 },
          640: { slidesPerView: 2 },
          576: { slidesPerView: 1 },
          0: { slidesPerView: 1 },
        }}
        navigation={{
          nextEl: `.ott-right-chevron-${id}`,
          prevEl: `.ott-left-chevron-${id}`,
        }}
        observeParents={true}
      >
        {currentItem?.mescOtts?.nodes.length > 0 &&
          currentItem?.mescOtts?.nodes?.map((item: any, ind: number) => (
            <SwiperSlide key={ind}>
              <OttCard currentCardItem={item} />
            </SwiperSlide>
          ))}
      </Swiper>
      <div className={`ott-left-chevron ott-left-chevron-${id}`}>
        <i className="flaticon-arrow-right"></i>
      </div>
      <div className={`ott-right-chevron ott-right-chevron-${id}`}>
        <i className="flaticon-arrow-right"></i>
      </div>
    </div>
  );
};

export default OttCarousel;
